import { ReactQuery } from '@codeleap/query'
import { React } from '@/config'
import { APIClient, Gyphi } from '@/services'
import { GlobalStyle, AppStatusOverlay, ChatComponents } from '@/components'
import { HydrationBoundary } from '@tanstack/react-query'
import { ModalOutlet } from '@codeleap/modals'
import { I18nProvider } from '@lingui/react'
import { i18n } from '@lingui/core'
import { NotificationsListener } from './notifications'
import { ChatGlobalListeners } from './chat/ChatGlobalListeners'

const App = ({ children }: React.PropsWithChildren) => {
  APIClient.Session.useSession(true)

  return (
    <>
      <GlobalStyle />
      <AppStatusOverlay />
      <ModalOutlet />
      {children}
      <ChatGlobalListeners />
    </>
  )
}

export const AppWrapper = ({ children, dehydratedState }: React.PropsWithChildren<{ dehydratedState: any }>) => {
  APIClient.usePersistQueryClient()

  return (
    <ReactQuery.QueryClientProvider client={APIClient.queryClient.client}>
      <HydrationBoundary state={dehydratedState}>
        <I18nProvider i18n={i18n}>
          <ChatComponents.ChatProvider>
            <ChatComponents.ChatProviderGate>
              <NotificationsListener />
            </ChatComponents.ChatProviderGate>

            <Gyphi.GyphiProvider>
              <App>
                {children}
              </App>
            </Gyphi.GyphiProvider>
          </ChatComponents.ChatProvider>
        </I18nProvider>
      </HydrationBoundary>
    </ReactQuery.QueryClientProvider>
  )
}
